import http from "../../http-common";
import StockAdjustment from '../stock-adjustment/StockAdjustment';
import { Receipt } from '@material-ui/icons';

const get = (data) => http.post("/StockConsult/FilterStockConsult", data);

const getByCodeProduct = (data) => http.post("/ReceiptProduct/GetByCodeProduct", data);

const getByBarCode = (data) => http.post("/ReceiptProduct/GetByBarCode", data);

const getByProductName = (data) => http.post("/ReceiptProduct/GetByProductName", data);

const saveHeader = (data) => http.post("/OutputProduct/SaveHeader", data);

const saveItens = (data) => http.post("/OutputProduct/SaveItens", data);

export default { get, getByCodeProduct, getByBarCode, getByProductName, saveHeader, saveItens };
